/* eslint-disable */
import Vue from 'vue'
import moment from 'moment-timezone'

class AppyUtil {

  constructor (ctx = null) {
    if (ctx !== null) {
      this.ctx = ctx
    }
  }

  getCookie (cname, req) {
    let name = cname + '='
    let decodedCookie
    if (typeof window === 'undefined') decodedCookie = decodeURIComponent(req.headers.cookie)
    else decodedCookie = decodeURIComponent(document.cookie)
    var ca = decodedCookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  }

  convertHexToRgba (hex, opacity) {
    hex = hex.replace('#','');
    let r = parseInt(hex.substring(0,2), 16);
    let g = parseInt(hex.substring(2,4), 16);
    let b = parseInt(hex.substring(4,6), 16);

    return 'rgba('+r+','+g+','+b+','+opacity/100+')';
  }

  getBrightness (hexCode) {
    // strip off any leading #
    hexCode = hexCode.replace('#', '');

    var c_r = parseInt(hexCode.substr(0, 2),16);
    var c_g = parseInt(hexCode.substr(2, 2),16);
    var c_b = parseInt(hexCode.substr(4, 2),16);

    return ((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000;
  }
}

const appyUtilPlugin = {
  install (Vue, options) {
    if (Vue.__nuxt_appyUtil_installed__) {
      return
    }
    Vue.__nuxt_appyUtil_installed__ = true

    if (!Vue.prototype.hasOwnProperty('$appyUtil')) {
      Object.defineProperty(Vue.prototype, '$appyUtil', {
        get () {
          return this.$root.$options.$appyUtil
        }
      })
    }

    /**
     * FILTERS
     */

    // domain extract filter
    Vue.filter('domainExtract', function (url) {
      var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
      if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
        return match[2];
      }
      else {
        return null;
      }
    })

    Vue.filter('toInt', function (val) {
      if (val !== null) {
        return parseInt(val);
      }
      return val;
    })

    Vue.filter('capitalize', function (val) {
      if (val !== null) {
        return val.charAt(0).toUpperCase() + val.slice(1);
      }
      return val;
    })

  }
}

Vue.use(appyUtilPlugin)

export default (ctx) => {
  const {app, store} = ctx

  const appyUtil = new AppyUtil(ctx)
  app.$appyUtil = appyUtil
  ctx.$appyUtil = appyUtil
  if (store) {
    store.$appyUtil = appyUtil
  }
}
